import { render, staticRenderFns } from "./ListTransferencias.vue?vue&type=template&id=040aadbf&"
import script from "./ListTransferencias.vue?vue&type=script&lang=js&"
export * from "./ListTransferencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports